import React, { useEffect, useState } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";

export const useFormStyles = makeStyles((theme) => ({
    infoHeader: {
        fontWeight: "bold",
        paddingBottom: "4px",
        color: theme.palette.text.primary, //'var(--text-dark)'
    },
    required: {
        color: "var(--text-error)",
    },
}));
const SidebarAccordian = (props) => {
    let { required } = props;
    const classes = useFormStyles();
    return (
        <Accordion expanded={props.expanded} onChange={props.onChangeHandler}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                    <FormattedMessage id={props.headerTitle} /> {required && <span className={classes.required}>*</span>}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </Accordion>
    );
};

export default SidebarAccordian;
